module.exports = __webpack_public_path__ + "img/page2-bg-phone.2c9ee5f7.png";